<template>
  <div class="promo-section" :class="{ black: $route.path === '/' }">
    <p class="text-center">
      <strong>90-Day Risk Free Trial.</strong> Free standard shipping &amp; free
      return shipping.
    </p>
  </div>
</template>

<script>
export default {
  name: "promo-section.vue",
};
</script>

<style scoped lang="scss">
.theme-dark {
  .promo-section {
    color: #ffffff;
  }
}
.theme-light {
  .promo-section {
    color: #000000;
  }
}
.promo-section {
  padding: 0 15px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.5s ease, color 0.5s ease;
  border-bottom: 1px solid #dddddd;
  p {
    margin: 0;
  }
}
</style>
